function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import DashboardLayout from '../layouts/DashboardLayout';
import Heading from '../Heading';
import { deleteOAuth2Application, getOAuth2Application, updateOAuth2Application } from '@/actions/AuthActions';
import { DynamicWebRoutes } from '@/utils/constants';
import { FormattedMessage, useIntl } from 'react-intl';
import SettingsPanel from '../SettingsPanel';
import { faIdBadge, faKey, faRefresh, faTrash, faWarning } from '@fortawesome/free-solid-svg-icons';
import Table from '../Table';
import InputModal, { DefaultInput } from '../InputModal';
import { isValidRedirectUri } from '@/utils/regex';
import { useDebouncedCallback } from 'use-debounce';
import { v4 as uuidv4 } from 'uuid';
import { Helmet } from 'react-helmet';
import { SettingPanels } from '@/types/client';
import BackButton from '../BackButton';
import { ActionIcon, Box, Button, Loader, Table as MantineTable, Text, Tooltip } from '@mantine/core';
import TableHeading from '../TableHeading';
import styles from './OAuthApplicationSettings.module.scss';
import classNames from 'classnames';
import Icon, { IconSizes } from '../Icon';
import { useDisclosure } from '@mantine/hooks';
import { CopyIconButton } from '../CopyTextButton';
var NAVIGATE_TO = {
    pathname: DynamicWebRoutes.SETTINGS(SettingPanels.CONNECTIONS)
};
export default function OAuth2ApplicationSettings() {
    var applicationId = useParams().applicationId;
    var intl = useIntl();
    var navigate = useNavigate();
    var _React_useState = _sliced_to_array(React.useState(null), 2), application = _React_useState[0], setApplication = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState([]), 2), redirectUris = _React_useState1[0], setRedirectUris = _React_useState1[1];
    var _useDisclosure = _sliced_to_array(useDisclosure(), 2), deleteApplicationModalOpen = _useDisclosure[0], deleteApplicationModalHandlers = _useDisclosure[1];
    var _useDisclosure1 = _sliced_to_array(useDisclosure(), 2), resetClientSecretModalOpen = _useDisclosure1[0], resetClientSecretModalHandlers = _useDisclosure1[1];
    React.useEffect(function() {
        if (applicationId == null) {
            navigate(NAVIGATE_TO);
            return;
        }
        getOAuth2Application(applicationId).then(function(application) {
            if (!('clientSecret' in application)) {
                navigate(NAVIGATE_TO);
            } else {
                setApplication(application);
                setRedirectUris(application.redirectUris.map(function(uri) {
                    return {
                        key: uuidv4(),
                        value: uri
                    };
                }));
            }
        }).catch(function() {
            return navigate(NAVIGATE_TO);
        });
    }, [
        applicationId,
        navigate
    ]);
    var removeOAuth2Application = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (applicationId == null) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        deleteOAuth2Application(applicationId)
                    ];
                case 1:
                    _state.sent();
                    navigate(NAVIGATE_TO);
                    return [
                        2
                    ];
            }
        });
    }), [
        applicationId,
        navigate
    ]);
    var addRedirectUri = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(uri) {
            return _ts_generator(this, function(_state) {
                if (application == null || redirectUris.length >= 5) {
                    return [
                        2
                    ];
                }
                setRedirectUris(function(uris) {
                    return _to_consumable_array(uris).concat([
                        {
                            key: uuidv4(),
                            value: uri
                        }
                    ]);
                });
                return [
                    2
                ];
            });
        });
        return function(uri) {
            return _ref.apply(this, arguments);
        };
    }(), [
        application,
        redirectUris.length
    ]);
    var resetClientSecret = React.useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var newApplication;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (application == null) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        updateOAuth2Application({
                            clientId: application.clientId
                        }, true)
                    ];
                case 1:
                    newApplication = _state.sent();
                    setApplication(newApplication);
                    return [
                        2
                    ];
            }
        });
    }), [
        application
    ]);
    var updateRedirectUris = useDebouncedCallback(function() {
        if ((application === null || application === void 0 ? void 0 : application.clientId) == null || redirectUris == null) {
            return;
        }
        var validRedirectUris = redirectUris.every(function(param) {
            var value = param.value;
            return isValidRedirectUri(value);
        });
        if (!validRedirectUris) {
            return;
        }
        updateOAuth2Application({
            clientId: application.clientId,
            redirectUris: redirectUris.map(function(param) {
                var value = param.value;
                return value;
            })
        }).then(function(newApplication) {
            return setApplication(newApplication);
        }).catch(console.error);
    }, 1000);
    var removeRedirectUri = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(redirectUriKey) {
            return _ts_generator(this, function(_state) {
                if (application == null) {
                    return [
                        2
                    ];
                }
                setRedirectUris(function(uris) {
                    return uris.filter(function(uri) {
                        return uri.key !== redirectUriKey;
                    });
                });
                updateRedirectUris();
                return [
                    2
                ];
            });
        });
        return function(redirectUriKey) {
            return _ref.apply(this, arguments);
        };
    }(), [
        application,
        updateRedirectUris
    ]);
    var updateRedirectUri = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(redirectUriKey, uri, finished) {
            return _ts_generator(this, function(_state) {
                if (application == null) {
                    return [
                        2
                    ];
                }
                if (finished && uri.length === 0) {
                    removeRedirectUri(redirectUriKey);
                    return [
                        2
                    ];
                }
                setRedirectUris(function(uris) {
                    return uris.map(function(u) {
                        return u.key === redirectUriKey ? {
                            key: u.key,
                            value: uri
                        } : u;
                    });
                });
                return [
                    2
                ];
            });
        });
        return function(redirectUriKey, uri, finished) {
            return _ref.apply(this, arguments);
        };
    }(), [
        application,
        removeRedirectUri
    ]);
    React.useEffect(function() {
        updateRedirectUris();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        application === null || application === void 0 ? void 0 : application.clientId,
        redirectUris
    ]);
    var updateApplicationName = useDebouncedCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(name) {
            return _ts_generator(this, function(_state) {
                if (application == null || name.length < 5 || name.length > 100) {
                    return [
                        2
                    ];
                }
                updateOAuth2Application({
                    clientId: application.clientId,
                    name: name
                }).then(setApplication).catch(console.error);
                return [
                    2
                ];
            });
        });
        return function(name) {
            return _ref.apply(this, arguments);
        };
    }(), 1000);
    if (application == null) {
        return /*#__PURE__*/ _jsx(DashboardLayout, {
            children: /*#__PURE__*/ _jsx(Box, {
                className: styles.loaderContainer,
                children: /*#__PURE__*/ _jsx(Loader, {})
            })
        });
    }
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            size: 'lg'
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "0a7mDK",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Application Settings"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(BackButton, {
                fallbackParams: NAVIGATE_TO,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "yDwLxa",
                    defaultMessage: "All Applications"
                })
            }),
            /*#__PURE__*/ _jsx(Heading, {
                size: "md",
                className: styles.applicationName,
                contentEditable: true,
                suppressContentEditableWarning: true,
                onBlur: function(param) {
                    var textContent = param.target.textContent;
                    return updateApplicationName(textContent !== null && textContent !== void 0 ? textContent : '');
                },
                children: application.name
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                icon: faIdBadge,
                heading: intl.formatMessage({
                    id: "U5+MBC",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Client ID"
                        }
                    ]
                }),
                description: application.clientId,
                afterElement: /*#__PURE__*/ _jsx(CopyIconButton, {
                    value: application.clientId,
                    buttonProps: {
                        size: 'lg'
                    },
                    hoverText: intl.formatMessage({
                        id: "1aGHyZ",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Copy Client ID"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                icon: faKey,
                heading: intl.formatMessage({
                    id: "ASwJRg",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Client Secret"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "nxKkNh",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "This is the client secret for the application."
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(CopyIconButton, {
                            hoverText: intl.formatMessage({
                                id: "BJKF4l",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Copy Client Secret"
                                    }
                                ]
                            }),
                            value: application.clientSecret,
                            buttonProps: {
                                size: 'lg'
                            }
                        }),
                        /*#__PURE__*/ _jsx(Tooltip, {
                            label: intl.formatMessage({
                                id: "ZRS9j3",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Reset Client Secret"
                                    }
                                ]
                            }),
                            children: /*#__PURE__*/ _jsx(ActionIcon, {
                                size: "lg",
                                "aria-label": intl.formatMessage({
                                    id: "ZRS9j3",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Reset Client Secret"
                                        }
                                    ]
                                }),
                                onClick: resetClientSecretModalHandlers.open,
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    size: IconSizes.SM,
                                    icon: faRefresh
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Table, {
                data: redirectUris,
                extraData: [
                    updateRedirectUri,
                    removeRedirectUri
                ],
                renderHeader: function() {
                    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                        children: [
                            /*#__PURE__*/ _jsx(TableHeading, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "Fwcz+y",
                                    defaultMessage: "Redirect URI"
                                })
                            }),
                            /*#__PURE__*/ _jsx(TableHeading, {
                                visibleFrom: "sm",
                                alignRight: true,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "wL7VAE",
                                    defaultMessage: "Actions"
                                })
                            })
                        ]
                    });
                },
                renderRow: function(param) {
                    var key = param.key, uri = param.value;
                    var isValid = isValidRedirectUri(uri);
                    return /*#__PURE__*/ _jsxs(MantineTable.Tr, {
                        children: [
                            /*#__PURE__*/ _jsxs(MantineTable.Td, {
                                className: classNames(styles.redirectUri, _define_property({}, styles.invalidUri, !isValid)),
                                children: [
                                    !isValid ? /*#__PURE__*/ _jsx(Icon, {
                                        icon: faWarning
                                    }) : null,
                                    /*#__PURE__*/ _jsx(Text, {
                                        size: "sm",
                                        onBlur: function(param) {
                                            var textContent = param.target.textContent;
                                            return updateRedirectUri(key, textContent !== null && textContent !== void 0 ? textContent : '', true);
                                        },
                                        contentEditable: true,
                                        suppressContentEditableWarning: true,
                                        children: uri
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(MantineTable.Td, {
                                className: styles.actionsColumn,
                                children: /*#__PURE__*/ _jsx(ActionIcon, {
                                    size: "sm",
                                    "aria-label": intl.formatMessage({
                                        id: "K3r6DQ",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Delete"
                                            }
                                        ]
                                    }),
                                    onClick: function() {
                                        return removeRedirectUri(key);
                                    },
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        size: IconSizes.SM,
                                        icon: faTrash
                                    })
                                })
                            })
                        ]
                    });
                },
                renderEmptyState: function() {
                    return /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "vexBrE",
                        defaultMessage: "No redirect URIs"
                    });
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.addRedirectUriFooter,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: "sm",
                        disabled: redirectUris.length >= 5,
                        onClick: function() {
                            return addRedirectUri('http://localhost:3000');
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "ArKna7",
                            defaultMessage: "Add Redirect URI"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        color: "textSecondary",
                        size: "sm",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "IUFOmz",
                            defaultMessage: "Max 5 Redirect URIs"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SettingsPanel, {
                icon: faWarning,
                heading: intl.formatMessage({
                    id: "YPRjdo",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Application"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "PZ8JP1",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to delete this application?"
                        }
                    ]
                }),
                afterElement: /*#__PURE__*/ _jsx(Button, {
                    size: "sm",
                    onClick: deleteApplicationModalHandlers.open,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "YPRjdo",
                        defaultMessage: "Delete Application"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: resetClientSecretModalOpen,
                onClose: resetClientSecretModalHandlers.close,
                title: intl.formatMessage({
                    id: "ZRS9j3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Reset Client Secret"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "iOkpMd",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to reset the client secret?"
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "ZRS9j3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Reset Client Secret"
                        }
                    ]
                }),
                onSubmit: resetClientSecret
            }),
            /*#__PURE__*/ _jsx(InputModal, {
                isOpen: deleteApplicationModalOpen,
                onClose: deleteApplicationModalHandlers.close,
                title: intl.formatMessage({
                    id: "YPRjdo",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Application"
                        }
                    ]
                }),
                renderInput: function(inputProps) {
                    return /*#__PURE__*/ _jsx(DefaultInput, _object_spread({
                        placeholder: application.name
                    }, inputProps));
                },
                validPredicate: function(value) {
                    return value === application.name;
                },
                description: intl.formatMessage({
                    id: "3JQP8l",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Are you sure you want to delete this application? Enter the application name to confirm."
                        }
                    ]
                }),
                submitText: intl.formatMessage({
                    id: "YPRjdo",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete Application"
                        }
                    ]
                }),
                onSubmit: removeOAuth2Application
            })
        ]
    });
}
